import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import states from 'app/assets/jsons/State.json';
import React, { useState } from 'react';
import { ComplianceCard } from './ComplianceCard';
import AMNLogo from 'app/assets/images/Placement/AMNLogo.svg';
import FacilityIcon from 'app/assets/images/Placement/Facility.svg';
import FederalIcon from 'app/assets/images/Placement/Federal.svg';
import StateIcon from 'app/assets/images/Placement/State.svg';
import { Divider, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectCredOneDetails, selectPlacementHeaderData } from 'store/redux-store/placement-details/selectors';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { LinearProgressBar } from '../CustomComponents/LinearProgressBar';
import { missingField } from 'app/constants';
import moment from 'moment';
import { makeStyles } from 'tss-react/mui';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles()(theme => ({
  root: {
    width: '100%',
    padding: '10px 5px',
  },
  complianceSectionRoot: {
    padding: '0px 15px !important',
    marginLeft: '-13px',
  },
  progressBarRoot: {
    padding: '15px 20px 10px 20px !important',
    marginLeft: '5px',
  },
  placementText: {
    marginLeft: '36px',
    marginTop: '-5px',
    color: '#888888',
  },
  complianceText: {
    fontWeight: 500,
  },
  divider: {
    paddingTop: '8px !important',
  },
}));

export const CompliancePercentageSection = () => {
  const credOneDetails = useSelector(selectCredOneDetails);
  const placementDetails = useSelector(selectPlacementHeaderData);
  const [isCompliant, setIsCompliant] = useState<boolean>(false);
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <LayoutGrid direction="column" className={classes.root}>
      <LayoutGridItem style={{ width: '100%' }}>
        <LayoutGrid direction="column" spacing={1} className={classes.complianceSectionRoot}>
          <LayoutGridItem>
            {isCompliant ? (
              <LayoutGrid alignItems={'center'}>
                <LayoutGridItem>
                  <CheckCircleOutlineIcon style={{ color: '#5FB661' }} />
                </LayoutGridItem>
                <LayoutGridItem>
                  <Typography className={classes.complianceText}>
                    {`Compliant - ${
                      credOneDetails?.dateCreated
                        ? moment(credOneDetails.dateCreated).format('MM/DD/YYYY hh:mm A')
                        : missingField
                    }`}
                  </Typography>
                </LayoutGridItem>
              </LayoutGrid>
            ) : (
              <LayoutGrid alignItems={'center'}>
                <LayoutGridItem>
                  <HighlightOffIcon color={'error'} />
                </LayoutGridItem>
                <LayoutGridItem>
                  <Typography className={classes.complianceText}>
                    {`Not Compliant - ${
                      credOneDetails?.dateCreated
                        ? moment(credOneDetails.dateCreated).format('MM/DD/YYYY hh:mm A')
                        : missingField
                    }`}
                  </Typography>
                </LayoutGridItem>
              </LayoutGrid>
            )}
          </LayoutGridItem>
          <LayoutGridItem>
            <Typography className={classes.placementText}>
              {`Placement ${credOneDetails?.placementId ? credOneDetails.placementId : missingField}`}
            </Typography>
          </LayoutGridItem>
        </LayoutGrid>
      </LayoutGridItem>
      <LayoutGridItem className={classes.progressBarRoot}>
        <LinearProgressBar value={30} filledItemscount={40} totalItems={100} size={'8px'} />
      </LayoutGridItem>
      <LayoutGridItem>
        <Divider />
      </LayoutGridItem>
      <LayoutGridItem>
        <ComplianceCard title={t('placement.profile.tabs.credOne.AMN')} image={AMNLogo} total={100} completed={30} />
      </LayoutGridItem>
      <LayoutGridItem className={classes.divider}>
        <Divider />
      </LayoutGridItem>
      <LayoutGridItem>
        <ComplianceCard
          title={t('placement.profile.tabs.credOne.Federal')}
          image={FederalIcon}
          total={100}
          completed={60}
        />
      </LayoutGridItem>
      <LayoutGridItem className={classes.divider}>
        <Divider />
      </LayoutGridItem>
      <LayoutGridItem>
        <ComplianceCard
          title={
            placementDetails?.facility?.state
              ? states.states.find(item => item.ID === placementDetails.facility.state).Description
              : '--'
          }
          image={StateIcon}
          total={100}
          completed={100}
        />
      </LayoutGridItem>
      <LayoutGridItem className={classes.divider}>
        <Divider />
      </LayoutGridItem>
      <LayoutGridItem>
        <ComplianceCard
          title={t('placement.profile.tabs.credOne.Facility')}
          image={FacilityIcon}
          total={100}
          completed={100}
        />
      </LayoutGridItem>
      <LayoutGridItem className={classes.divider}>
        <Divider />
      </LayoutGridItem>
    </LayoutGrid>
  );
};
